<template>
  <layout-header />
  <layout-sidebar />

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="me-2 mb-2">
            <div
              class="d-flex align-items-center border bg-white rounded p-1 me-2"
            >
              <router-link to="/crm/clients" class="btn btn-icon btn-sm me-1">
                <i class="ti ti-list-tree"></i>
              </router-link>
              <router-link
                to="/crm/clients-grid"
                class="btn btn-icon btn-sm active bg-primary text-white"
              >
                <i class="ti ti-layout-grid"></i>
              </router-link>
            </div>
          </div>

          <div class="me-2 mb-2">
            <button v-can="'Client.Export'" class="btn btn-white d-inline-flex align-items-center" @click="exportCsv">
              <i class="ti ti-file-type-csv me-1"></i>Export CSV
            </button>
          </div>

          <div class="mb-2">
            <a
              v-can="'Client.Create'"
              href="javascript:void(0);"
              class="btn btn-primary d-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#add_client"
              @click="openAddModal"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Client
            </a>
          </div>

          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Clients Info (KPIs) -->
      <div class="row">
        <!-- Total -->
        <div class="col-xl-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 me-2">
                    <span
                      class="p-2 br-10 bg-pink-transparent border border-pink d-flex align-items-center justify-content-center"
                    >
                      <i class="ti ti-users-group text-pink fs-18"></i>
                    </span>
                  </div>
                  <div>
                    <p class="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                      Total Clients
                    </p>
                    <h4>{{ kpis.total }}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Active -->
        <div class="col-xl-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 me-2">
                    <span
                      class="p-2 br-10 bg-success-transparent border border-success d-flex align-items-center justify-content-center"
                    >
                      <i class="ti ti-user-share fs-18"></i>
                    </span>
                  </div>
                  <div>
                    <p class="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                      Active Clients
                    </p>
                    <h4>{{ kpis.active }}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Inactive -->
        <div class="col-xl-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 me-2">
                    <span
                      class="p-2 br-10 bg-danger-transparent border border-danger d-flex align-items-center justify-content-center"
                    >
                      <i class="ti ti-user-pause fs-18"></i>
                    </span>
                  </div>
                  <div>
                    <p class="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                      Inactive Clients
                    </p>
                    <h4>{{ kpis.inactive }}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- New (last 30 days) -->
        <div class="col-xl-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 me-2">
                    <span
                      class="p-2 br-10 bg-info-transparent border border-info d-flex align-items-center justify-content-center"
                    >
                      <i class="ti ti-user-plus fs-18"></i>
                    </span>
                  </div>
                  <div>
                    <p class="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                      New Clients
                    </p>
                    <h4>{{ kpis.newCurr }}</h4>
                  </div>
                </div>
                <!-- Optional % trend badge available via fmtPct(kpis.newPct) -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Clients Info -->

      <!-- Card header with filters/sort -->
      <div class="card">
        <div class="card-body p-3">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
          >
            <h5>Client Grid</h5>
            <div class="d-flex align-items-center flex-wrap row-gap-3">
              <!-- Status -->
              <div class="dropdown me-2">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  {{ statusLabel }}
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setStatus(null)"
                      >All</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setStatus('Active')"
                      >Active</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setStatus('Inactive')"
                      >Inactive</a
                    >
                  </li>
                </ul>
              </div>

              <!-- Sort -->
              <div class="dropdown">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Sort By : {{ sortLabel }}
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setSort('recent')"
                      >Recently Added</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setSort('name_asc')"
                      >Name A → Z</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setSort('name_desc')"
                      >Name Z → A</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Clients Grid -->
      <div class="row">
        <!-- skeleton when loading and nothing yet -->
        <template v-if="store.loading && !clients.length">
          <div
            v-for="i in 8"
            :key="'sk-' + i"
            class="col-xl-3 col-lg-4 col-md-6"
          >
            <div class="card">
              <div class="card-body">
                <div class="placeholder-glow mb-3" style="height: 120px">
                  <span class="placeholder col-12 h-100"></span>
                </div>
                <div class="placeholder-glow">
                  <span class="placeholder col-6"></span>
                  <span class="placeholder col-4"></span>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- grid -->
        <div v-for="c in paged" :key="c.id" class="col-xl-3 col-lg-4 col-md-6">
          <div class="card">
            <div class="card-body">
              <!-- top row -->
              <div
                class="d-flex justify-content-between align-items-start mb-2"
              >
                <div class="form-check form-check-md">
                  <input class="form-check-input" type="checkbox" />
                </div>

                <div>
                  <router-link
                    :to="{ name: 'crm.clients.details', params: { id: c.id } }"
                    class="avatar avatar-xl avatar-rounded"
                    :class="[
                      (c.Status || 'Active') === 'Active'
                        ? 'online'
                        : 'offline',
                      'border',
                      'p-1',
                      'border-primary',
                      'rounded-circle',
                    ]"
                  >
                    <img
                      :src="c.Image || fallbackAvatar"
                      class="img-fluid h-auto w-auto"
                      alt="avatar"
                    />
                  </router-link>
                </div>

                <div class="dropdown">
                  <button
                    class="btn btn-icon btn-sm rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-dots-vertical"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end p-3">
                    <!-- <li>
                      <router-link
                       
                        :to="{
                          name: 'crm.clients.details',
                          params: { id: c.id },
                        }"
                        @click.stop
                        title="View"
                      >
                        <i class="ti ti-eye me-1 ml-2"></i>
                        View
                      </router-link>
                    </li> -->
                    <li>
                      <a
                        class="dropdown-item rounded-1"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#add_client"
                        @click="openEdit(c)"
                      >
                        <i class="ti ti-edit me-1"></i>Edit
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item rounded-1"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#delete_client"
                        @click.stop.prevent="openDeleteModal(c)"
                      >
                        <i class="ti ti-trash me-1"></i>Delete
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- center name + status -->
              <div class="text-center mb-3">
                <h6 class="mb-1">
                  <router-link
                    :to="{ name: 'crm.clients.details', params: { id: c.id } }"
                  >
                    {{ c.ClientName }}
                  </router-link>
                </h6>
                <span
                  class="badge fs-10 fw-medium"
                  :class="
                    (c.Status || 'Active') === 'Active'
                      ? 'bg-success-transparent border border-success'
                      : 'bg-danger-transparent border border-danger'
                  "
                >
                  {{ c.Status || "Active" }}
                </span>
              </div>

              <p class="mb-2 text-truncate">
                Project : <span class="text-muted">{{ c.project_name }}</span>
              </p>
              <div class="progress progress-xs mb-2">
                <div
                  class="progress-bar bg-purple"
                  role="progressbar"
                  :style="{ width: (c.project_progress || 0) + '%' }"
                ></div>
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <div class="avatar-list-stacked avatar-group-sm">
                  <span
                    v-for="(av, i) in c.member_avatars"
                    :key="i"
                    class="avatar avatar-rounded"
                  >
                    <img
                      :src="av || fallbackAvatar"
                      class="border border-white"
                      alt="team"
                    />
                  </span>
                  <a
                    v-if="c.member_extra > 0"
                    class="avatar bg-primary avatar-rounded text-fixed-white fs-12"
                    href="javascript:void(0);"
                    >+{{ c.member_extra }}</a
                  >
                </div>
                <span class="text-purple">{{ c.project_progress }}%</span>
              </div>

              <!-- bottom row -->
              <div
                class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"
              >
                <div>
                  <p class="mb-1 fs-12">Company</p>
                  <h6 class="fw-normal text-truncate">
                    {{ c.CompanyName || c.ClientName }}
                  </h6>
                </div>
                <div class="icons-social d-flex align-items-center">
                  <a
                    :href="c.Email ? `mailto:${c.Email}` : 'javascript:void(0);'"
                    class="avatar avatar-rounded avatar-sm bg-light me-2"
                    :aria-disabled="!c.Email"
                  >
                    <i class="ti ti-message"></i>
                  </a>
                  <a
                    :href="c.Phone ? `tel:${c.Phone}` : 'javascript:void(0);'"
                    class="avatar avatar-rounded avatar-sm bg-light"
                    :aria-disabled="!c.Phone"
                  >
                    <i class="ti ti-phone"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Load More -->
        <div class="col-md-12" v-if="hasMore || store.loading">
          <div class="text-center mb-4">
            <button
              class="btn btn-primary"
              :disabled="store.loading || !hasMore"
              @click="loadMore"
            >
              <span
                v-if="store.loading"
                class="spinner-border spinner-border-sm me-1"
              ></span>
              <i v-else class="ti ti-loader-3 me-1"></i>
              <span v-if="hasMore">Load More</span>
              <span v-else>All caught up</span>
            </button>
          </div>
        </div>
      </div>
      <!-- /Clients Grid -->
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>

  <!-- Modal (reuse the same as list page) -->
  <ClientsModal
    ref="modalRef"
    :client="editing"
    :next-code="nextClientCode"
    @refresh="reload"
  />
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useCrmClientStore } from "@/stores/crmClientStore";
import ClientsModal from "@/components/modal/clients-list-modal.vue";

const title = "Clients";
const text = "Employee";
const text1 = "Client Grid";

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

const store = useCrmClientStore();
const clients = computed(() => store.clients || []);
const fallbackAvatar = require("@/assets/img/users/user-01.jpg");

/* ---------------- Filters / Sort ---------------- */
const filters = ref({ status: null, sort: "recent" });

const statusLabel = computed(() =>
  filters.value.status ? `Status: ${filters.value.status}` : "Select Status"
);
const sortLabel = computed(() =>
  filters.value.sort === "name_asc"
    ? "Name A → Z"
    : filters.value.sort === "name_desc"
    ? "Name Z → A"
    : "Last 7 Days"
);

function setStatus(s) {
  filters.value.status = s;
}
function setSort(s) {
  filters.value.sort = s;
}

/* ---------------- Mapping client to card fields ---------------- */
// const mapped = computed(() =>
//   clients.value.map((c) => ({
//     _raw: c,
//     id: c.id,
//     ClientID: c.client_code || `CLT-${String(c.id).padStart(4, "0")}`,
//     ClientName: c.name,
//     CompanyName: c.company_name || c.name,
//     Email: c.email,
//     Phone: c.phone,
//     Status: c.status || "Active",
//     Image: c.logo_url,
//     created_at: c.created_at,
//   }))
// );

const mapped = computed(() =>
  (store.clients || []).map((c) => {
    const hp = c.highlight_project || null;
    const members = hp?.members || [];
    const top3 = members.slice(0, 3);
    const extra = Math.max(0, members.length - 3);

    console.log("CLients",store.clients.slice(0, 3));
    return {
      _raw: c,
      id: c.id,
      ClientID: c.client_code || `CLT-${String(c.id).padStart(4, "0")}`,
      ClientName: c.name,
      CompanyName: c.company_name || c.name,
      Email: c.email,
      Phone: c.phone,
      Status: c.status || "Active",
      Image: c.logo_url,
      created_at: c.created_at,

      // NEW: project summary for the card
      project_name: hp?.name || "—",
      project_progress: Number.isFinite(hp?.progress) ? hp.progress : 0,
      member_avatars: top3.map((u) => u.avatar_url || null),
      member_extra: extra,
    };
  })
);

/* ---------------- Filter + Sort ---------------- */
const filtered = computed(() => {
  let rows = [...mapped.value];
  if (filters.value.status) {
    rows = rows.filter(
      (r) =>
        (r.Status || "").toLowerCase() === filters.value.status.toLowerCase()
    );
  }
  switch (filters.value.sort) {
    case "name_asc":
      rows.sort((a, b) =>
        (a.ClientName || "").localeCompare(b.ClientName || "")
      );
      break;
    case "name_desc":
      rows.sort((a, b) =>
        (b.ClientName || "").localeCompare(a.ClientName || "")
      );
      break;
    default:
      rows.sort(
        (a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0)
      );
  }
  return rows;
});

/* ---------------- Lightweight "Load More" pagination ---------------- */
const pageSize = ref(12);
const visible = ref(pageSize.value);

const paged = computed(() => filtered.value.slice(0, visible.value));
const hasMore = computed(() => visible.value < filtered.value.length);
function loadMore() {
  visible.value += pageSize.value;
}

function exportCsv() {
  const header = ["Client ID", "Name", "Company", "Email", "Phone", "Status", "Project", "Progress", "Created"];
  const body = filtered.value.map((client) => [
    client.ClientID || "",
    client.ClientName || "",
    client.CompanyName || "",
    client.Email || "",
    client.Phone || "",
    client.Status || "",
    client.project_name || "",
    `${Number(client.project_progress || 0)}%`,
    client.created_at || "",
  ]);
  const csv = [header, ...body]
    .map((row) => row.map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`).join(","))
    .join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `crm-clients-grid-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/* ---------------- KPIs (match list-page logic) ---------------- */
const NEW_WINDOW_DAYS = 30;
function asDate(v) {
  if (!v) return null;
  if (v instanceof Date) return v;
  if (typeof v === "string") {
    const s = v.trim();
    // Handle "YYYY-MM-DD HH:mm:ss" safely
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(s)) {
      // If backend times are UTC-ish, append 'Z'; if they are local server time, omit 'Z'
      return new Date(s.replace(" ", "T") + "Z");
      // or: return new Date(s.replace(' ', 'T'));  // if you want local time
    }
  }
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

function pctChange(curr, prev) {
  if (prev === 0) return null;
  return ((curr - prev) / prev) * 100;
}

const kpis = computed(() => {
  const rows = clients.value || [];
  const total = rows.length;
  const active = rows.filter(
    (c) => (c.status || "").toLowerCase() === "active"
  ).length;
  const inactive = rows.filter(
    (c) => (c.status || "").toLowerCase() === "inactive"
  ).length;

  const now = new Date();
  const startCurr = new Date(now);
  startCurr.setDate(now.getDate() - NEW_WINDOW_DAYS);
  const startPrev = new Date(now);
  startPrev.setDate(now.getDate() - 2 * NEW_WINDOW_DAYS);
  const endPrev = new Date(now);
  endPrev.setDate(now.getDate() - NEW_WINDOW_DAYS);

  const inRange = (d, from, to) => {
    const dt = asDate(d);
    return dt && dt >= from && dt < to;
  };

  const newCurr = rows.filter((c) =>
    inRange(c.created_at || c.createdAt, startCurr, now)
  ).length;

  const newPrev = rows.filter((c) =>
    inRange(c.created_at || c.createdAt, startPrev, endPrev)
  ).length;
  const newPct = pctChange(newCurr, newPrev);

  return { total, active, inactive, newCurr, newPct };
});

/* ---------------- Actions (reuse modal from list page) ---------------- */

function openAddModal() {
  editing.value = null;
}

const editing = ref(null);
const modalRef = ref(null);
const toDelete = ref(null);

function openEdit(row) {
  console.log("Hello", row);
  editing.value = row._raw || null;
}

function openDeleteModal(row) {
  editing.value = row._raw || null;
}

const nextClientCode = computed(() => {
  if (!clients.value?.length) return "CLT-0001";
  const nums = clients.value
    .map((c) => c.client_code || c.code || c.ClientID) // try common fields
    .filter(Boolean)
    .map((code) => parseInt(String(code).replace(/[^\d]/g, ""), 10))
    .filter((n) => !Number.isNaN(n));
  const next = (Math.max(...nums, 0) + 1).toString().padStart(4, "0");
  return `CLT-${next}`;
});

/* ---------------- Boot ---------------- */
function reload() {
  store.fetchClients();
}
onMounted(reload);
</script>

<style scoped>
/* optional tiny skeletons */
.placeholder {
  display: inline-block;
  background: #f2f3f5;
  border-radius: 4px;
}
.placeholder-glow .placeholder {
  animation: glow 1.2s ease-in-out infinite;
}
@keyframes glow {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 0.6;
  }
}

/* preserve your grid look */
.avatar.offline::after {
  background: #adb5bd;
}
</style>


